export const loadScript = (id: string, src: string) => {
  let elt = document.getElementById(id);
  if (!elt) {
    let script = document.createElement('script');
    script.src = src;
    document.getElementsByTagName('head')[0].appendChild(script);
  }
};
